import { appendCdnHostName } from '../../../../utility/geoUtils';

export const VOUCHER_TYPE_CUSTOM = 'custom';
export const VOUCHER_TYPE_DISCOUNT = 'discount';
export const VOUCHER_TYPE_PERCENTAGE = 'percentage';
export const VOUCHER_TYPE_DOLLAR = 'dollar';

export const ALL_VOUCHER_TYPE_INFO = [
  {
    type: VOUCHER_TYPE_PERCENTAGE,
  },
  {
    type: VOUCHER_TYPE_DOLLAR,
  },
  {
    type: VOUCHER_TYPE_CUSTOM,
  },
];

export const VOUCHER_INFO_TAGLINE = 'tagline';
export const VOUCHER_INFO_DETAILS = 'details';

export const VOUCHER_MAX_CHAR_LENGTH = 127;
export const MESSAGE_TO_DONORS_MAX_BYTE_LENGTH = 127;
export const VOUCHER_MAX_FILE_SIZE = 2000000; // 2MB
export const ALLOWED_FILE_EXTENSIONS = ['jpg', 'gif', 'png'];
export const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/gif', 'image/png'];
export const MESSAGE_INTERPOLATION_KEY = '{businessName}';

export const VOUCHER_INPUT_FIXED = 'FIXED';
export const VOUCHER_INPUT_PERCENTAGE = 'PERCENTAGE';
export const VOUCHER_INPUT_CUSTOM = 'CUSTOM';
export const VOUCHER_DISCOUNT_DEFAULT_VALUE = 5;

export const GENERIC_VOUCHER_FLOW = 'generic';
export const DEFAULT_LOGO_URL = appendCdnHostName(
  '/ppcp/images/covid/donations@x600.png'
);
export const DISPLAY_DEFAULT_MERCHANT_NAME = 'Acme Inc';

export const INVALID_ADDRESS_ERROR = 'INVALID_ADDRESS';
